import React from 'react'
import { Link } from 'react-router-dom'
import fanltvLogo from '../../assets/fanltv-logo.svg'
import '../../styles/admin-v2.css'

export const FANVUE_APP_STORE_URL = 'https://www.fanvue.com/app-store'
export const SUPPORT_EMAIL = 'hello@fanltv.com'

export default function PublicSiteShell({ children, variant = 'app' }) {
  const toolsMode = variant === 'tools'
  const brandContent = (
    <>
      <span className="v2-brand-mark">
        <img src={fanltvLogo} alt="" aria-hidden="true" />
      </span>
      <span>
        <strong>FanLTV</strong>
        <em>{toolsMode ? 'Free tools' : 'Fanvue app'}</em>
      </span>
    </>
  )

  return (
    <div className={`v2-public-shell${toolsMode ? ' v2-public-shell-tools' : ''}`}>
      <header className={`v2-public-header${toolsMode ? ' v2-public-header-tools' : ''}`}>
        {toolsMode ? (
          <a className="v2-public-brand" href="https://fanltv.com/" aria-label="FanLTV home">{brandContent}</a>
        ) : (
          <Link className="v2-public-brand" to="/connect/fanvue" aria-label="FanLTV Fanvue connection">{brandContent}</Link>
        )}
        <nav className="v2-public-nav" aria-label="Public pages">
          {toolsMode ? (
            <>
              <a href="https://fanltv.com/platform/">Product</a>
              <a href="https://fanltv.com/solutions/fansly-fyp/">Fansly FYP</a>
              <a href="https://fanltv.com/evidence/">Results</a>
              <details className="v2-public-tools-menu">
                <summary>Free tools</summary>
                <div>
                  <a href="https://fanltv.com/tools/"><strong>All free tools</strong><span>Start without an integration</span></a>
                  <Link to="/tools/chatter-score" aria-current="page"><strong>ChatterScore</strong><span>Find conversation revenue leaks</span></Link>
                  <a href="https://fanltv.com/tools/ltv-calculator/"><strong>LTV Profit Calculator</strong><span>Model retention and unit economics</span></a>
                </div>
              </details>
              <a href="https://fanltv.com/events/">Events</a>
              <a className="v2-public-pilot" href="https://fanltv.com/pilot/">Book a pilot</a>
            </>
          ) : (
            <>
              <Link to="/tools/chatter-score">ChatterScore</Link>
              <Link to="/support">Support</Link>
              <Link to="/privacy">Privacy</Link>
              <Link to="/terms">Terms</Link>
            </>
          )}
        </nav>
      </header>

      <main className="v2-public-main">{children}</main>

      {toolsMode ? (
        <footer className="v2-public-footer v2-public-footer-tools">
          <div><strong>FanLTV</strong><span>AI revenue operations for creator agencies.</span></div>
          <div><a href="https://fanltv.com/solutions/">Revenue scenarios</a><a href="https://fanltv.com/solutions/fansly-fyp/">Fansly FYP</a><a href="https://fanltv.com/integrations/">Integrations</a><a href="https://fanltv.com/events/">Events</a></div>
          <div><Link to="/privacy">Privacy</Link><Link to="/terms">Terms</Link><a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a></div>
        </footer>
      ) : (
        <footer className="v2-public-footer">
          <div><Link to="/data-deletion">Data deletion</Link><a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a></div>
          <a href={FANVUE_APP_STORE_URL} target="_blank" rel="noreferrer">Fanvue App Store</a>
        </footer>
      )}
    </div>
  )
}
